import React, { Component } from 'react'
import { reportRef, artistRef, REST_API_URL } from '../../config'
import { eliminateDuplicates } from '../../utils'
import agent from 'superagent-bluebird-promise'
import {Line} from 'rc-progress'
import SelectSearch from 'react-select-search'
import './select-search.css'
import Alert from 'react-s-alert'
import { Row, Col } from 'reactstrap';

import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/scale.css'


export default class Calculator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      percentageSellout: 0,
      showResults: false,
      artistsLoading:false,
      venuesLoading: false,
      ticketPrice:0,
      minSeat:undefined,
      maxSeat:undefined,
      section:undefined,
      numberOfTickets:undefined,
      row:undefined,
      venue: '',
      'artist':'',
      venueQuery: '',
      result: {},
      history: {},
      options: []
    }
    this.onCurrentTicketPriceChange = this.onCurrentTicketPriceChange.bind(this)
    this.onNumberOfTicketsChange = this.onNumberOfTicketsChange.bind(this)
    this.onRowChange = this.onRowChange.bind(this)
    this.onMinSeatChange = this.onMinSeatChange.bind(this)
    this.onMaxSeatChange = this.onMaxSeatChange.bind(this)
    this.venueChange = this.venueChange.bind(this)
    this.onSectionChange = this.onSectionChange.bind(this)
    this.artistChange = this.artistChange.bind(this)
    this.submit = this.submit.bind(this)
    this.startSimulation = this.startSimulation.bind(this)
    this.filterVenues = this.filterVenues.bind(this)
  }

  venueChange(e) {
    this.setState({
      venue: e
    })
  }

  artistChange(e) {
    this.setState({
      artist: e.target.value
    })
  }

  onRowChange(e) {
    this.setState({
      row:e.target.value
    })
  }

  onMinSeatChange(e) {
    this.setState({
      minSeat: e.target.value
    })
  }
  onMaxSeatChange(e) {
    this.setState({
      maxSeat: e.target.value
    })
  }

  onSectionChange(e) {
    this.setState({
      section: e.target.value
    })
  }

  filterVenues(e) {
    const regex = new RegExp(this.state.venueQuery, 'gi')
    if(!this.state.venueQuery) {
      return this.state.options
    }
    return this.state.options.filter(option => option.value.match(regex))
  }

  componentDidMount() {
    agent
    .get(REST_API_URL+'/venues')
    .then(res => {
      console.log('venues', res)
      let initialVenues = res.body.map(venue => venue.Venue)
      let uniqueVenues = eliminateDuplicates(res.body.map(venue => venue.Venue)).map(v => ({name:v, value:v}))
      console.log(uniqueVenues.length)
      this.setState({
        options:uniqueVenues
      })
    })
    agent
    .get(REST_API_URL+'/artists')
    .then(res => {
      this.setState({
        artistOptions: res.body.map(artist => ({name:artist.name, value: artist.name}))
      })
    })
  }

  submit() {
    console.log('submitting', this.state)
    if(Object.keys(this.state.result).length > 0) {
      console.log('true')
      this.setState({
        result: {},
        venuesLoading: true
      })
    }
    console.log('yoo', this.state.venue)
    agent
    .post(REST_API_URL+'/ai')
    .send({
      artist:this.state.artist, 
      venue:this.state.venue,
      ticketCost:this.state.ticketPrice,
      ticketQty: this.state.numberOfTickets
    })
    .then(res => {

      this.setState({
        result: res.body,
        showResults: true,
        venuesLoading: false
      })
    })
  }


  onCurrentTicketPriceChange(e) {
    this.setState({
      ticketPrice: e.target.value
    })

  }
  onNumberOfTicketsChange(e) {
    this.setState({
      numberOfTickets: e.target.value
    })
  }
  startSimulation = () => {
    console.log('start simulation called')
    let totalProfit = 0
    let avgProfit = 0
    let bestTicketProfit = 0
    let sampleSize = 0
    let estimatedProfit = 0
    let worstSale = 0
    let profitAfterFees = 0
    let profitObj = this.state.history[this.state.venue.label+this.state.artist.label] !== undefined ? this.state.history[this.state.venue.label+this.state.artist.label]: undefined
    console.log('start simulation called with', this.state)
    if(this.state.history[this.state.venue.label+this.state.artist.label] !== undefined) {
      console.log('already have result')
      this.setState({result: profitObj})
      return
    }
    for(let i =0; i< 100; i++) {
      let thisProfit = Math.random() * 100
      if(thisProfit > bestTicketProfit)
        bestTicketProfit = thisProfit
      totalProfit += thisProfit
    }
    avgProfit = Math.floor(Math.round(totalProfit / 100))
    sampleSize = Math.floor(Math.round(Math.random()*100))
    estimatedProfit = Math.floor(Math.round((totalProfit - Math.random())))
    worstSale = Math.floor(Math.round(bestTicketProfit - (bestTicketProfit*0.5)))
    profitAfterFees = Math.floor(Math.round(estimatedProfit - (estimatedProfit*0.10)))
    profitObj = {
      avgProfit,
      sampleSize,
      estimatedProfit,
      profitAfterFees,
      totalProfit: Math.round(totalProfit),
      worstSale,
      bestTicketProfit
    }
    console.log('new profit obj', profitObj)
    //this.state.history[this.state.venue.label + this.state.artist.label] = profitObj
    this.setState({result: profitObj, showResults: true, guess:true})
    
  }

  render() {
    console.log(this.state.result)
    let headingStyle = {
      backgroundColor:'#0f3e9f',
      color:'#fff'
    }
    let hrStyle = {
      color:'black'
    }
    let iconLookup = {
      pastSaleCountAtPricePoint: 'fa fa-hashtag',
      pastSaleCount: 'fa fa-hashtag',
      requestedPricePoint: 'icon ion-cash',
      pastPricePoints:'icon ion-list',
      totalProfitOnPastSales: 'icon ion-cash',
      ticketQty: 'fa fa-hashtag',
      predictedProfitPerTicket: 'icon ion-cash',
      predictedROI:'icon ion-cash',
      inputForCalculator: 'icon ion-calculator',
      venue: 'fa fa-building',
      sellPricePerTicket: 'icon ion-cash',
      profitPerTicket: 'icon ion-cash',
      numberOfEvents: 'fa fa-hashtag',
      message: 'fa fa-envelope-o'

    }
    let wellNodes = Object.keys(this.state.result).length > 0 ? Object.keys(this.state.result).filter(k => k!== 'events').map((k, index) => 
      <div style={{margin:'auto', display:'block'}}className="col-sm-4">
      <div className="well well-lg filter-view text-center">
        <span className="filter-icon"><i className={iconLookup[k]}></i></span>
        <h4 style={headingStyle} className="album-heading">{k.split(/(?=[A-Z])/).join(" ").toUpperCase()}</h4>
        <hr style={hrStyle} />
        <span className="fa-2x">{k === 'message' ? this.state.result[k]: this.state.result[k]}</span>
      </div>
    </div>): []
    return (
    <div className='animated fadeIn'>
      <div className='card'>
        <div className='card-header'>
          <strong> Decision </strong>
          <small> Form </small>
        </div>
        <div className='card-block'>
          <Row>
            <Col xs="12" md="6" lg="4">
              <div className='form-group'>
                <label htmlFor='Artist'> Artist </label>
                 <SelectSearch options={this.state.artistOptions} value={this.state.artist} onChange={(artist) => this.setState({artist})} name="artist" placeholder="Choose your artist" />
              </div>
            </Col>
            <Col xs="12" md="6" lg="4">
              <div className='form-group'>
                <label htmlFor='Venue'> Venue </label>
                <SelectSearch options={this.state.options} value={this.state.venue} onChange={(venue) => this.setState({venue:venue.name})} name="venue" placeholder="Choose your venue" />
              </div>
            </Col>
            <Col xs="12" md="6" lg="4">
              <div className='form-group'>
                <label htmlFor='ticketPrice'> Current Ticket Price </label>
                <input type='text' className='form-control' id='ticketPrice' placeholder='20' onChange={this.onCurrentTicketPriceChange} value={this.state.ticketPrice}/>
              </div>
            </Col>
            <Col xs="12" md="6" lg="4">
              <div className='form-group'>
                <label htmlFor='ticketQty'> ticket QTY </label>
                <input type='text' className='form-control' id='ticketQty' placeholder='20' onChange={this.onNumberOfTicketsChange} value={this.state.numberOfTickets}/>
              </div>
            </Col>
          </Row>
          <div className='form-group text-right'>
            <button className='btn btn-success' onClick={this.submit}> Submit </button>
          </div>
        </div>
      </div>
      <div className='text-center'> 
        {this.state.guess ? <p className='text-muted'> this is a guess </p>: ''}
      </div>
      <div className='text-center'> 
        {this.state.showResults ?
          <div className='row text-center'>
           {wellNodes}
          </div>: null
      }
      
      <Alert stack={{limit: 3}} />
    </div>
  </div>)

  }
}



// WEBPACK FOOTER //
// ./src/views/Calculator/Calculator.js